module.exports = {"450103001":"新竹街道","450103002":"中山街道","450103003":"建政街道","450103004":"南湖街道","450103005":"津头街道","450103006":"仙葫经济开发区管理委员会","450103100":"刘圩镇","450103101":"南阳镇","450103102":"伶俐镇","450103103":"长塘镇","450103451":"青秀山管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450103.json
// module id = 1896
// module chunks = 0